/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_SubtitleInputs */

const en_link_editor_subtitle = /** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your portfolio and socials.`)
};

const es_link_editor_subtitle = /** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona tu portafolio y redes sociales.`)
};

const fr_link_editor_subtitle = /** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez votre portfolio et vos réseaux sociaux.`)
};

const de_link_editor_subtitle = /** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte dein Portfolio und deine sozialen Netzwerke.`)
};

/** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */
const ja_link_editor_subtitle = en_link_editor_subtitle;

/** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */
const zh_link_editor_subtitle = en_link_editor_subtitle;

/** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */
const ar_link_editor_subtitle = en_link_editor_subtitle;

/** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */
const id_link_editor_subtitle = en_link_editor_subtitle;

/** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */
const it_link_editor_subtitle = en_link_editor_subtitle;

/** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */
const ru_link_editor_subtitle = en_link_editor_subtitle;

/** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */
const pt_link_editor_subtitle = en_link_editor_subtitle;

/** @type {(inputs: Link_Editor_SubtitleInputs) => LocalizedString} */
const ko_link_editor_subtitle = en_link_editor_subtitle;

/**
* | output |
* | --- |
* | "Manage your portfolio and socials." |
*
* @param {Link_Editor_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_subtitle = /** @type {((inputs?: Link_Editor_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_subtitle(inputs)
	if (locale === "es") return es_link_editor_subtitle(inputs)
	if (locale === "fr") return fr_link_editor_subtitle(inputs)
	if (locale === "de") return de_link_editor_subtitle(inputs)
	if (locale === "ja") return ja_link_editor_subtitle(inputs)
	if (locale === "zh") return zh_link_editor_subtitle(inputs)
	if (locale === "ar") return ar_link_editor_subtitle(inputs)
	if (locale === "id") return id_link_editor_subtitle(inputs)
	if (locale === "it") return it_link_editor_subtitle(inputs)
	if (locale === "ru") return ru_link_editor_subtitle(inputs)
	if (locale === "pt") return pt_link_editor_subtitle(inputs)
	return ko_link_editor_subtitle(inputs)
});